import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { toast } from 'react-toastify';

import Sez from './Sezione.png';
import Sezo from './CPT_sez.png';
import SeisOver from './Sismic_overlap.png';
import CPT_see from './CPT_see.png';
import CPT_lito from './CPT_lito.png';
import CPT_graph from './CPT_graph.png';
import CPT_Over from './Overlap_data.png';

import { useTranslation } from 'react-i18next';

function Geoutilities() {

    const { t, i18n } = useTranslation();

    const images = [
        CPT_graph, // Replace with your image URLs
        CPT_lito,
        CPT_see,
        Sezo,
        Sez,
        SeisOver
    ];

    const descriptions = t('pages.geoutpg.imgdescr', { returnObjects: true });

    const [currentIndex, setCurrentIndex] = useState(0); // State to track the current image index

    // Function to go to the previous image
    const prevImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    // Function to go to the next image
    const nextImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const navigate = useNavigate(); // Create a navigate function

    const handleButtonDownl = async () => {
        const repoUrl = 'http://repository.sofhare.com/repository_sH_geoTool_xa5ggye';
    
        try {
            await navigator.clipboard.writeText(repoUrl);
    
            toast.success('Repository QGIS copiata');
    
        } catch (err) {
            console.error('Errore copia:', err);
            toast.error('Errore durante la copia');
        }
    };

    const handleButtonClick = () => {
        window.open('https://community.sofhare.com/c/videocorsi/11', '_blank');
    };

    return(

        <div className="main-wrapper">
            <div className="tools-wrapperS2" id="idgeout">
                <h1> {t('pages.geoutpg.t1')}</h1>
                <div className="sez2" >
                  <div className="text-im">
                    <p >{t('pages.geoutpg.t2')}</p>
                        <ul className="text-im-list">
                        {/* Lista di paragrafi, evita i <br/> */}
                        {[t('pages.geoutpg.dsc1'),t('pages.geoutpg.dsc2'),t('pages.geoutpg.dsc3'),
                        t('pages.geoutpg.dsc4'),t('pages.geoutpg.dsc5'),t('pages.geoutpg.dsc6'),
                        t('pages.geoutpg.dsc7'),t('pages.geoutpg.dsc8')].map((i) => (
                          <li key={i} className="text-im-paragraph">
                            {t(`${i}`)}
                          </li>
                        ))}
                        </ul>
                  </div>
                </div>
           </div>
           <div className="tools-wrapperS1">
               <div className="sez1" >
                     <div className="bloc-cont">
                        <div className="ic2">
                            <h3 className="preview-title">{t('pages.geoutpg.t3')} </h3>
                            <div className="image-and-description">
                              <img
                                src={images[currentIndex]} // immagine corrente
                                alt={`Image ${currentIndex + 1}`}
                                className="carousel-image"
                              />
                              <p className="image-description">
                                {descriptions[currentIndex]}
                              </p>
                              {/* Puntini di navigazione */}
                              <div className="dots">
                                {images.map((_, idx) => (
                                  <span
                                    key={idx}
                                    className={`dot ${idx === currentIndex ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(idx)}
                                  ></span>
                                ))}
                              </div>
                            </div>
                        </div>
                        <div className="ic2" onClick={handleButtonDownl}>
                            <h3 className="preview-title">{t('pages.geoutpg.t4')} </h3>
                            <img src={CPT_Over} alt="Blog Preview" className="carousel-image" />
                        </div>
            </div>
           </div>
       </div>
      </div>

    );
}


export default Geoutilities;
